import { hashStr } from './coins';
import type { GameEvent } from '../api/types';

/** Дейлик за вход (GAME_LAYER: дейлик): детерминирован датой — идемпотентен на любом устройстве. */
export const DAILY_BASE = 5;
export const DAILY_CRIT = 15;

export function dailyReward(dateIso: string): { coins: number; crit: boolean } {
  const crit = hashStr('daily' + dateIso) % 100 < 18;
  return { coins: crit ? DAILY_CRIT : DAILY_BASE, crit };
}

export function dailyEventId(dateIso: string): string {
  return `dl_${dateIso}`;
}

export function hasDailyLogin(events: GameEvent[], dateIso: string): boolean {
  return events.some((e) => e.type === 'daily_login' && e.week === dateIso);
}
